(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment historie item
    module.controller('AgendaAfterNewAppointmentModalController',
        ['$uibModalInstance', 'message', AgendaAfterNewAppointmentModalControllerFn]);

    function AgendaAfterNewAppointmentModalControllerFn($uibModalInstance, message) {
        var vm = this;
        vm.message = null;

        activate();

        // activation work
        function activate() {
            vm.message = message;
        } // activate

        // close
        vm.close = function () {
            $uibModalInstance.dismiss();
        };

    }

})();